import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-368e791c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "业务参数详情", -1))


import Modal from '@/hooks/modalType'
import { reactive, onMounted, ref } from 'vue'
import { listByParamCodes } from '@/api/common'
import { potentialList } from '@/api/gucangSales/customerCenter'

import { CustomerCode } from '@/typings/api/customerCenter'
const __default__ = { name: 'list' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref<{toggle :(row?: CustomerCode) => void}>()

const tableRef = ref()
const queryForm = reactive({
  name: ''
})

onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_grade', 'zbu_partner_nature', 'zbu_main_customers', 'zbu_campaign_type', 'zbu_partner_role']
  }).then((res) => {
    if (res.code === 200) {
      console.log(11)
    }
  })
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  potentialList(params).then((res) => {
    callBack(res)
  })
}
// const success = () => {
//   tableRef.value.fetch()
// }
const columns = ref([
  { title: '业务参数', dataIndex: 'noset' },
  { title: '关联参数', dataIndex: 'noset' },
  {
    title: '状态',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: CustomerCode) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: CustomerCode) => {
  Modal.delete({
    name: row.arkCode,
    onOk() {
      tableRef.value?.delFetch()
      console.log(1)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!

  return (_openBlock(), _createBlock(_component_dc_layout_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_button, {
          type: "primary",
          class: "btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode("业务参数")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_cos_table, {
        serial: "",
        columns: columns.value,
        onFetch: fetch,
        search: queryForm,
        "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((queryForm) = $event)),
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'action')
            ? (_openBlock(), _createBlock(_component_more_button, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (addEdit(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (deleteRow(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "search"])
    ]),
    _: 1
  }))
}
}

})